<template>
  <div class="_2zoVUbLx">
    <div class="_1SI39Ofv" v-if="show">
      <div class="_9-ZpLxb0">
        <img
          src="data:image/png;base64,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"
          alt="icon"
        />
        <div class="_3_qzGcRD"><span class="_1N8mCmac">-</span><span>B</span><span>O</span><span>B</span><span>.</span><span>C</span><span>O</span><span>M</span><span class="_1N8mCmac">-</span></div>
      </div>
    </div>
    <video src="/static/image/bg_batch-0ac1.mp4" class="_2FBwK8pA" autoplay="" preload="preload" loop=""></video>
    <div class="_2qyICCAn">
      <div class="DZfPXDqq">
        <a><img src="/static/image/w_logo1-a238.png" /></a>
      </div>
      <div class="_1xYhiAzf">
        <h3 class="_1xOfyRAi">用户注册</h3>
        <ul class="_9s4xncLL" id="yanzhangma">
          <li class="FzjZ-TwQ">
            <input type="text" name="userName" class="" maxlength="32" placeholder="请输入帐号（最少6位，英文及数字）" autocomplete="off" value="" />
            <i class="_3pvR4aic _3-xMSbk3"></i>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="passWord" class="" maxlength="32" placeholder="请输入密码（最少8位，英文及数字）" autocomplete="new-password" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i>
            <span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="confirmPass" class="" maxlength="32" placeholder="请重复输入您的密码" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="text" name="realname" class="" maxlength="32" placeholder="请输入您真实姓名（中，英文）" value="" />
            <i class="_3pvR4aic _3-xMSbk3"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="paypassword" maxlength="6" class="" placeholder="请输入6位取款密码" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ x2AzF1GR">
            <input type="text" name="validCode" class="" v-model="code" placeholder="验证码" autocomplete="off" data-analytics="button" data-label="注册-验证码" value="" />
            <i class="_3pvR4aic _1tbGk_Vo"></i>
            <div class="_3zcM8MXv">
              <img :src="`/static/image/yzm/${imgLis[index]}.png`" class="_1_iUfFmJ" />
              <img
                @click="changIndex"
                data-analytics="button"
                data-label="注册-获取验证码"
                src="data:image/png;base64,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"
                class="_112M2iQB"
              />
            </div>
          </li>

          <li>
            <div class="_19rglWPh">
              <label class="_1XkWFucM ant-checkbox-wrapper ant-checkbox-wrapper-checked"
                ><span class="ant-checkbox ant-checkbox-checked">
                  <input type="checkbox" class="ant-checkbox-input" value="" checked="" />
                  <span class="ant-checkbox-inner"></span></span
              ></label>
              <i>我已阅读并同意相关的<a>条款</a>和<a>隐私政策</a>。</i>
            </div>
          </li>
          <li>
            <div class="_349CzCYy xJQe3jRu Ntuq7wDg" @click="login"><span>注册</span></div>
          </li>
          <li style="margin-top: 0px; position: relative">
            <div class="_1ZEbIiBK"><span>已经有帐号? </span><a @click="goNav('/login')">请登录</a></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      index: 0,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],

      code: '',
      show: false,
      pid: '',
    };
  },
  components: {},
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.pid) {
      that.pid = query.pid;

    }
    that.changIndex();
  },
  mounted() {
    $("input[name='userName']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });
    $("input[name='realname']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });

    $("input[name='passWord']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='confirmPass']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='paypassword']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='validCode']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });
    //点击小眼睛
    var i = true; //显示开关
    $('.eyes').click(function () {
      if (i) {
        $(this).addClass('_1xpiRCSg');
        $(this).prevAll('input').attr('type', 'text');
        i = false;
      } else {
        $(this).removeClass('_1xpiRCSg');
        $(this).prevAll('input').attr('type', 'password');
        i = true;
      }
    });
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    goNav(url) {
      let that = this;
      this.$router.push({ path: url });
    },
    login() {
      let that = this;

      let info = {
        name: $("input[name='userName']").val(),
        password: $("input[name='passWord']").val(),
        confirmPass: $("input[name='confirmPass']").val(),
        realname: $("input[name='realname']").val(),
        paypassword: $("input[name='paypassword']").val(),
      };
      console.log(info);
      // 用户名验证
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //不得低于6位，以字母或数字组合！
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; //以字母或数字组合！不低于8位
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; //中英文姓名
      let paypasswordreg = /^.{6,6}$/; //只能是6位
      let codereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,}$/; //以字母或数字组合 不低于4位

      if (namereg.test(info.name) == false) {
        that.showTost(' 用户名长度不得低于6位，以字母和数字组合！');
        return;
      }

      if (passwordreg.test(info.password) == false) {
        that.showTost('密码长度最少8位！以字母和数字组合！');
        return;
      }
      if (info.confirmPass != info.password) {
        that.showTost('两次密码不一致！');
        return;
      }
      if (realnamereg.test(info.realname) == false) {
        that.showTost('姓名格式不正确，可以是中，英文名称！');
        return;
      }

      if (paypasswordreg.test(info.paypassword) == false) {
        that.showTost('支付密码长度需是6位！！');
        return;
      }

      if (codereg.test(that.code) == false || that.code.toUpperCase() != that.imgLis[that.index]) {
        that.showTost('验证码错误！');
        that.code = '';
        that.changIndex();
        return;
      }
      that.show = true;
      if (that.pid) {
        info.pid = that.pid;
      }
      that.$apiFun.register(info).then(res => {
        that.showTost(res.message);

        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');

          that.getUserInfo();
        }
        that.show = false;
      });
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));

          that.$store.commit('changUserInfo');
          that.goNav('/');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fangda {
  animation: _308UEapr 0.5s ease-out;
}
.hover {
  display: none;
}
._3gi7jqcw:hover ._2JoosS9F {
  display: none;
}
._3gi7jqcw:hover .hover {
  display: block;
}
._3gi7jqcw._12ZkQT2g ._2JoosS9F {
  display: none;
}
._3gi7jqcw._12ZkQT2g .hover {
  display: block;
}
.ant-tabs-nav .ant-tabs-tab {
  height: 46px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue